<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row dense>
      <v-btn
        class="ma-2 no-display"
        tile
        outlined
        color="warning"
        @click="print()"
      >
        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
      </v-btn>
      <v-btn class="button no-display" @click="dialog_marks = true"
        >Give Remark</v-btn
      >
    </v-row>
    <div
      class="container"
      style="background-color: white"
      flat
      v-if="leraner_marksheet != ''"
    >
      <div class="jumbotron1">
        <div class="jumbotron">
          <div class="row" dense>
            <img
              class="center_box ml-10"
              src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_1.jpeg"
              style="height: 150px"
              alt="logo"
            />
            <v-spacer></v-spacer>
            <img
              class="center_box2"
              src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_2.jpeg"
              style="height: 150px"
              alt="logo"
            />
          </div>
          <div class="center_box3">
            <div>
              <center>
                <strong>
                  <span class="trust-name" style="font-size: 1.2em"
                    >PIMPRI CHINCHWAD EDUCATION TRUST'S</span
                  >
                </strong>
              </center>
              <strong>
                <center>
                  <span class="schl-name">S.B. PATIL PUBLIC SCHOOL</span>
                </center>
              </strong>
              <strong>
                <center>
                  <span class="stud-info" style="font-size: 1.2em"
                    >CBSE CURRICULUM</span
                  >
                </center>
              </strong>
              <strong>
                <center>
                  <span class="stud-info" style="font-size: 1.2em"
                    >Pre - Primary</span
                  >
                </center>
              </strong>
              <strong>
                <center>
                  <span class="stud-info" style="font-size: 1.2em"
                    >Progress Card {{ ay }}</span
                  >
                </center>
              </strong>
            </div>
            <div>
              <v-row class="stud-info" dense justify="center">
                <span v-if="photo != null">
                  <center>
                    <img
                      :src="awspath + photo"
                      style="width: 150px; height: 150px"
                      alt="logo"
                    />
                    <h3>PRN: {{ reg_no }}</h3>
                  </center>
                </span>
                <span v-else>
                  <center>
                    <img
                      class="report-img"
                      src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                      style="width: 150px; height: 150px"
                      alt="logo"
                    />
                    <h3>PRN: {{ reg_no }}</h3>
                  </center>
                </span>
              </v-row>
            </div>
            <div>
              <div class="stud-info" style="font-size: 1.2em" justify="center">
                <v-row class="text" dense>
                  <v-col cols="12" sm="2" md="2"
                    ><strong>Name : </strong>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{ name }}
                    <hr class="new2" />
                  </v-col>
                </v-row>
                <v-row class="text" dense>
                  <v-col cols="12" sm="2" md="2"
                    ><strong>Std : </strong>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    {{ standard }}
                    <hr class="new2" />
                  </v-col>
                  <v-col cols="12" sm="2" md="2"
                    ><strong>Div : </strong>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    justify-self="left"
                    align="left"
                  >
                    {{ div }}
                    <hr class="new2" />
                  </v-col>
                </v-row>
                <v-row class="text" dense>
                  <v-col cols="12" sm="2" md="2"
                    ><strong>Roll No. : </strong>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{ roll_no }}
                    <hr class="new2" />
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <!-- </v-img> -->
        </div>
      </div>
      <div class="page">
        <div class="pagebreak page1 ml-5 mr-5">
          <center>
            <strong class="crs-name"><u>ACADEMIC PROGRESS</u></strong>
          </center>
          <br /><br /><br /><br />
          <span
            v-for="s in leraner_marksheet.coscholastic_leraner_marksheet"
            :key="s.c_id"
          >
            <v-col cols="12" sm="12" md="12" class="margin_result">
              <!-- <strong
                ><u class="crs-name">{{ s.crs_name }}</u></strong
              > -->
              <v-row>
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <div class="table-breaked">
                  <v-simple-table flat dense>
                    <thead>
                      <tr>
                        <td>
                          <strong
                            ><u class="crs-name">{{ s.crs_name }}</u></strong
                          >
                        </td>
                        <td
                          class="th"
                          v-for="header in leraner_marksheet.ass_details_for_marksheet"
                          :key="header"
                        >
                          <center>{{ header }}</center>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(header, index) in s.rubric_header"
                        :key="index"
                      >
                        <div style="width: 900px">{{ header.rubric }}</div>
                        <td
                          class="th"
                          v-for="(g, index) in header.grade"
                          :key="index"
                        >
                          <center>
                            <img
                              :src="g"
                              style="width: 40px; height: 43px"
                              alt="logo"
                            />
                          </center>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
                <!-- </v-col> -->
              </v-row>
            </v-col>
          </span>
          <div class="pageNo">
            <span><b>-1-</b></span>
          </div>
        </div>
        <!-- page no. -->
        <!-- <div align="center" class="pageNo"><b></b></div> -->

        <!-- <center><span class="page-number">-</span></center> -->

        <div class="pagebreak page1 ml-5 mr-5">
          <span v-if="leraner_marksheet.leraner_marksheet != ''">
            <center>
              <strong class="crs-name"
                ><u> This is what my teacher feels about me </u></strong
              >
            </center>
            <br /><br />
            <!-- <br /><br /> -->
            <span
              v-for="s in leraner_marksheet.leraner_marksheet"
              :key="s.c_id"
            >
              <v-col cols="12" sm="12" md="12" class="margin_result">
                <!-- <strong
                  ><u class="crs-name">{{ s.crs_name }}</u></strong
                > -->
                <v-row>
                  <!-- <v-col cols="12" sm="12" md="12"> -->
                  <div class="table-breaked">
                    <v-simple-table flat dense>
                      <thead>
                        <tr>
                          <td>
                            <strong
                              ><u class="crs-name">{{ s.crs_name }}</u></strong
                            >
                          </td>
                          <td
                            class="th"
                            v-for="header in leraner_marksheet.ass_details_for_marksheet"
                            :key="header"
                          >
                            <center>{{ header }}</center>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(header, index) in s.rubric_header"
                          :key="index"
                        >
                          <div style="width: 900px">{{ header.rubric }}</div>
                          <td
                            class="th"
                            v-for="(g, index) in header.grade"
                            :key="index"
                          >
                            <center>
                              <img
                                :src="g"
                                style="width: 40px; height: 43px"
                                alt="logo"
                              />
                            </center>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                  <!-- </v-col> -->
                </v-row>
              </v-col>
            </span>
          </span>
          <div class="pageNo">
            <span><b>-2-</b></span>
          </div>
        </div>

        <!-- <center><span class="page-number">-</span></center> -->

        <div class="pagebreak page1 ml-5 mr-5">
          <span v-if="leraner_marksheet.other_leraner_marksheet != ''">
            <span
              v-for="s in leraner_marksheet.other_leraner_marksheet"
              :key="s.c_id"
            >
              <v-col cols="12" sm="12" md="12" class="margin_result">
                <!-- <strong
                  ><u class="crs-name">{{ s.crs_name }}</u></strong
                > -->
                <v-row>
                  <!-- <v-col cols="12" sm="12" md="12"> -->
                  <div class="table-breaked">
                    <v-simple-table flat dense>
                      <thead>
                        <tr>
                          <td>
                            <strong
                              ><u class="crs-name">{{ s.crs_name }}</u></strong
                            >
                          </td>
                          <td
                            class="th"
                            v-for="header in leraner_marksheet.ass_details_for_marksheet"
                            :key="header"
                          >
                            <center>{{ header }}</center>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(header, index) in s.rubric_header"
                          :key="index"
                        >
                          <div style="width: 900px">{{ header.rubric }}</div>
                          <td
                            class="th"
                            v-for="(g, index) in header.grade"
                            :key="index"
                          >
                            <center>
                              <img
                                :src="g"
                                style="width: 40px; height: 43px"
                                alt="logo"
                              />
                            </center>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                  <!-- </v-col> -->
                </v-row>
              </v-col>
            </span>
          </span>
          <!-- bmi and attendence -->
          <div class="ml-5 mr-5">
            <br />

            <span v-if="leraner_marksheet.display_bmi == 'True'">
              <center>
                <strong class="crs-name"><u>BMI Details</u></strong>
              </center>
              <br />

              <v-simple-table
                v-if="leraner_marksheet != ''"
                fixed-header
                dense
                class="elevation-1"
              >
                <tr>
                  <td rowspan="3" class="th">
                    <center><strong>Health Status</strong></center>
                  </td>
                </tr>
                <tr>
                  <td class="th"><center>Height(cm)</center></td>
                  <td class="th"><center>Weight(kg)</center></td>
                  <td class="th"><center>BMI</center></td>
                </tr>
                <tr>
                  <td
                    class="th"
                    v-for="(s, index2) in leraner_marksheet.user_bmi_list_sem"
                    :key="index2"
                  >
                    <center>{{ s }}</center>
                  </td>
                </tr>
              </v-simple-table>
            </span>
          </div>

          <div class="ml-5 mr-5">
            <br />
            <span v-if="leraner_marksheet.sem_attendance != ''">
              <center>
                <strong class="crs-name"><u>Student Attendance</u></strong>
              </center>
              <br />
              <!-- <span v-for="s in leraner_marksheet.sem_attendance" :key="s">
                AA--{{ s.total_working_days_sem }}p
              </span> -->
              <v-simple-table
                v-if="leraner_marksheet != ''"
                fixed-header
                dense
                class="elevation-1"
              >
                <tbody>
                  <tr>
                    <td class="th">
                      <center>
                        <strong>Total Attendance of the Student</strong>
                      </center>
                    </td>
                    <td
                      class="th"
                      v-for="(s, index2) in leraner_marksheet.sem_attendance"
                      :key="index2"
                    >
                      <center>
                        {{ s.present }}/{{ s.total_working_stud }}
                      </center>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </span>
          </div>
          <br />
          <v-col class="col_border" cols="12" sm="12" md="12">
            <strong class="crs-name"><u>Remarks</u>&nbsp;:</strong>
            <span class="l-remark"> {{ leraner_marksheet.lms_remark }}</span>
          </v-col>
          <br />
          <v-col class="col_border" cols="12" sm="12" md="12">
            <v-row dense class="crs-name">
              <v-col cols="4" sm="4" md="4">
                <br />
                <center>Class Teacher</center>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <br />
                <center>Principal's Signature</center>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <br />
                <center>Parent's Signature</center>
              </v-col>
            </v-row>
          </v-col>
          <br />
          <center>
            <strong class="crs-name"
              ><u>Student Performance Indicators</u></strong
            >
          </center>
          <br />
          <v-col class="col_border" cols="12" sm="12" md="12">
            <v-row dense justify="center">
              <v-col
                cols="12"
                sm="2"
                md="2"
                v-for="(
                  s, index
                ) in leraner_marksheet.grading_scheme_details_for_marksheet"
                :key="index"
              >
                <img
                  :src="s.grade_symbol"
                  style="width: 50px; height: 50px"
                  alt="logo"
                />
                <br />
                {{ s.grade }}
              </v-col>
            </v-row>
          </v-col>
          <div class="pageNo">
            <span><b>-3-</b></span>
          </div>
        </div>
        <!-- <div align="center" class="pageNo"><b></b></div> -->

        <!-- <center><span class="page-number">-</span></center> -->
      </div>
    </div>
    <v-dialog v-model="dialog_marks" persistent max-width="1200px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Give Remark </strong>
          </v-toolbar-title>
        </v-toolbar>
        <center>
          <v-col cols="12" sm="6" md="6">
            <!-- <v-textarea outlined color="#0F2027" flat dense v-model="remark" name="remark" placeholder="Give Remark" label="Remark"></v-textarea> -->
            <v-autocomplete
              dense
              rounded
              outlined
              multiple
              v-model="remark"
              :items="default_value"
              color="#0F2027"
              item-text="value"
              item-value="value"
              label="Remark"
              single-line
            ></v-autocomplete>
          </v-col>
        </center>
        <v-row justify="center">
          <v-btn rounded class="button" @click="saveremark">Save</v-btn>
          <v-btn rounded class="button" @click="dialog_marks = false"
            >Close</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    org: Number,
  },
  data() {
    return {
      default_value: [],
      dialog_marks: false,
      overlay: false,
      selected: [],
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      show: false,
      course_list: [],
      stud_list: [],
      awspath: "",
      registration_no: null,
      standard: null,
      div: null,
      ay: null,
      name: null,
      dob: null,
      roll_no: null,
      mobile_no: null,
      address: null,
      mother_name: null,
      photo: null,
      reg_no: null,
      gr_no: null,
      father_full_name: null,
      leraner_marksheet: [],
      semester: null,
      colspan: null,
      overall_grade: null,
      remark: [],
    };
  },

  methods: {
    saveremark() {
      const data = {
        lms_id: this.leraner_marksheet.lms_id,
        remark: this.remark,
      };
      axios
        .post("/Examination/saveremark", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Remark save successfully...!");
            this.onload();
            this.dialog_marks = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.remark = [];
        });
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      //  alert(this.sem)
      const data = {
        lid: this.registration_no,
        ay: this.sel_ay_data,
        sem: this.sem,
        org: this.org,
      };
      axios
        .post("/Examination/getpreprimaryStudentReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.standard = res.data.standard;
            this.div = res.data.div;
            this.ay = res.data.ay;
            this.name = res.data.name;
            this.dob = res.data.dob;
            this.roll_no = res.data.roll_no;
            this.mobile_no = res.data.mobile_no;
            this.address = res.data.address;
            this.mother_name = res.data.mother_name;
            this.photo = res.data.photo;
            this.reg_no = res.data.reg_no;
            this.gr_no = res.data.gr_no;
            this.father_full_name = res.data.father_full_name;
            this.leraner_marksheet = res.data.leraner_marksheet;
            this.semester = res.data.semester;
            this.default_value = res.data.default_value;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    // this.sel_ay_data = this.$store.getters.ay;
    // this.registration_no = this.$store.getters.reg_no;
    // this.sem = this.$store.getters.sem;
    this.sel_ay_data = localStorage.getItem("setay");
    this.sem = localStorage.getItem("setsem");
    this.registration_no = localStorage.getItem("setreg_no");
    this.onload();
  },
};
</script>
<style scoped>
.margin_result {
  margin-left: 5%;
  margin-right: 5%;
}
.text_report {
  border: 3px solid black;
  margin: 1rem !important;
}

.col_border {
  border-bottom: 1px solid black !important;
  border-top: 1px solid black !important;
  border-right: 1px solid black !important;
  border-left: 1px solid black !important;
}
thead {
  font-weight: bold !important;
}
th {
  font-weight: bold !important;
}
td {
  font-size: small;
}
.th {
  border: 1px solid black;
  border-bottom: 1px solid black;
  font-size: small;
  width: 70% !important;
}
.tr {
  border: 1px solid black;
  border-collapse: collapse;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  /* text-align: center; */
  font-size: small;
}

.t-row {
  padding: 1rem i !important;
}

.v-dialogss {
  bottom: 880;
  right: 0;
}
.center_box {
  position: absolute;
  top: 12%;
  left: 20%;
  text-align: center;
  font-size: 18px;
}
.center_box2 {
  position: absolute;
  top: 12%;
  left: 70%;
  font-size: 18px;
}
.center_box3 {
  /* position: absolute; */
  /* top: 11%; */
  width: 100%;
  font-size: 18px;
  margin-top: 40%;
}

.text {
  margin-left: 30%;
  padding: 1%;
}
.schl-name {
  font-size: 1.5em;
}
@media print {
  #content {
    display: table;
  }

  .margin_result {
    margin: 0% !important;
  }
  .center_box3 {
    position: absolute;
    top: 2% !important;
    width: 100%;
  }
  .stud-info {
    font-size: 28px !important;
  }
  .schl-name {
    font-size: 38px !important;
  }
  .trust-name {
    /* font-size: 28px !important; */
  }
  .center_box {
    position: absolute;
    top: 9% !important;
    left: 15%;
    text-align: center;
    font-size: 18px;
  }
  .center_box2 {
    position: absolute;
    top: 9% !important;
    left: 70%;
    font-size: 18px;
  }
  /* .card {
    border: none !important;
    font-size: large !important;
  } */
  .pagebreak {
    page-break-before: always;
    margin-top: 1rem !important;
    /* counter-increment: page; */
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  /* v-card {
    border: none !important;
    font-size: large !important;
  } */
  .crs-name {
    font-size: 30px !important;
  }
  .l-remark {
    font-size: 25px !important;
  }

  .jumbotron {
    height: 1700px !important;
    background-size: cover;
    /* margin-top: -35px;
    padding-bottom: 35px; */
    /* background-size: 100% 100%; */
  }

  .th img {
    width: 55px !important;
    height: 55px !important;
  }
  /* .pageNo {
    font-size: 25px !important;
    visibility: visible !important;
   
  } */
  .page .page-number {
    visibility: visible !important;
  }
  .page1 {
    position: relative;
    height: 1670px;
    /* width: 100%; */
  }
  .pageNo {
    position: absolute;
    bottom: 0px;
    text-align: center;
    font-size: 22px;
    width: 100%;
    visibility: visible !important;
  }
  @page {
    size: A4;
    margin-top: 0px !important;
    /* margin: none; */
    /* padding-top: -6%; */
    padding-bottom: none;
    /* size: 13in 17.5in; */
    size: 13in 18in;
  }

  .table-breaked {
    page-break-inside: avoid;
    /* page-break-before: auto; */
    margin-top: 1rem;
  }
  thead {
    font-weight: bold !important;
  }
}
ol.s {
  list-style-type: inherit;
}
.inf {
  text-decoration: underline;
  text-decoration-style: dashed;
}
hr.new2 {
  border-top: 1px dashed black;
}

.jumbotron {
  font-family: "Nunito Sans" sans-serif;
  background: url("https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/sbpps/ReportCard/final_view_report_75.png")
    no-repeat center center;
  background-size: 100% 100%;
  height: 1400px;
  padding-top: 5%;
  padding-bottom: 1%;
}
/* page number */
.pageNo {
  visibility: hidden;
}
.page {
  counter-reset: page;
}
.page .page-number {
  font-size: 22px;
  visibility: hidden;
  margin-bottom: 0;
  font-weight: bold;
}
.page .page-number:after {
  counter-increment: page;
  content: counter(page);
}
.page .page-number {
  font-size: 22px;
  visibility: hidden;
  margin-bottom: 0;
  font-weight: bold;
}
</style>
